import React from 'react'
import { Box, Card, CardContent, Link } from '@mui/material'

const TermsAndConditionsSection: React.FC = () => (
    <Box sx={{ marginTop: '2rem' }}>
        <Card
            sx={{
                margin: '0 auto',
                padding: '1.5rem',
                backgroundColor: '#3D3D3D',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
            }}>
            <CardContent sx={{ color: 'white' }}>
                <h1>Regulamin korzystania z Usługi TOYA GO</h1>
                <h2>I. POSTANOWIENIA OGÓLNE</h2>
                <ol>
                    <li>
                        Regulamin określa zakres i warunki korzystania z
                        dostępu, drogą elektroniczną, poprzez publiczną sieć
                        Internet, do wskazanych treści multimedialnych i
                        wybranych funkcjonalności dodatkowych Usługi TOYA GO.
                        Usługa TOYA GO jest udostępniana na warunkach
                        określonych w Regulaminie korzystania z Usługi TOYA GO
                        zwanym dalej ,,Regulaminem TOYA GO” i jest objęta Umową
                        o korzystanie z usług TOYA, zwaną dalej ,,Umową”, o
                        której mowa w Regulaminie korzystania z Usług TOYA.
                    </li>
                    <li>
                        Użyte Regulaminie TOYA GO określenia, nazwy i skróty
                        oznaczają:
                        <ol>
                            <li>
                                <b>Usługa TOYA GO</b> – usługa świadczona drogą
                                elektroniczną, zapewniająca dostęp do serwisu
                                multimedialnego będącego własnością TOYA sp. z
                                o.o.,
                            </li>
                            <li>
                                <b>Aplikacja</b> – udostępniana nieodpłatnie
                                aplikacja dająca dostęp do Usługi TOYA GO
                                pobierana za pośrednictwem strony internetowej
                                TOYA www.toya.net.pl oraz sklepów internetowych
                                Apple App Store oraz Google Play,
                            </li>
                            <li>
                                <b>Użytkownik</b> – użytkownik Aplikacji
                                korzystający z Usługi TOYA GO w Pakiecie
                                Otwartym,
                            </li>
                            <li>
                                <b>Abonent</b> – osoba fizyczna posiadająca
                                pełną zdolność do czynności prawnych albo osoba
                                prawna, albo jednostka nie posiadająca
                                osobowości prawnej, z którą zawarto Umowę,
                            </li>
                            <li>
                                <b>Dostęp do sieci Internet</b> - dostęp do
                                sieci Internet w technologii przewodowej lub
                                bezprzewodowej wymagany do działania Aplikacji,
                                którego zapewnienie jest po stronie Abonenta,
                            </li>
                            <li>
                                <b>Terminal Abonencki</b> – urządzenie będące
                                własnością Użytkownika lub Abonenta,
                                przystosowane do komunikacji z siecią Internet
                                i/lub możliwością zainstalowania Aplikacji,
                            </li>
                            <li>
                                <b>Treści multimedialne</b> – dowolnie wybrane i
                                udostępniane przez Operatora:
                                <ol>
                                    <li>
                                        programy telewizyjne w czasie
                                        rzeczywistym (online),
                                    </li>
                                    <li>
                                        audycje radiowe w czasie rzeczywistym
                                        (online),
                                    </li>
                                    <li>materiały z bazy VOD,</li>
                                    <li>
                                        materiały Catch-up TV / Start over -
                                        możliwe do odtworzenia programy
                                        telewizyjne do 2 dni wstecz
                                    </li>
                                </ol>
                                oraz wszelkie inne materiały tekstowe,
                                graficzne, multimedialne oraz usługi
                                elektroniczne udostępniane za pośrednictwem
                                Usługi TOYA GO.
                                <br />
                                Treści te stanowią treści cyfrowe w rozumieniu
                                przepisów ustawy z dnia 30 maja 2014r, o prawach
                                konsumenta (Dz. U. 2014.827) i nie są zapisane
                                na nośniku materialnym.
                            </li>
                            <li>
                                <b>Funkcjonalności dodatkowe</b> - dowolnie
                                wybrane i udostępniane przez Operatora dodatkowe
                                funkcjonalności dostępne w Usłudze TOYA GO
                                oprócz Treści multimedialnych, dostarczające w
                                szczególności:
                                <ol>
                                    <li>
                                        możliwość zdalnego planowania nagrywania
                                        programów telewizyjnych na Urządzeniu
                                        dostępowym Abonenta,
                                    </li>
                                    <li>
                                        dostępu do elektronicznego przewodnika
                                        po programie TV (EPG),
                                    </li>
                                    <li>
                                        dostępu do obrazu z kamer internetowych.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                <b>Pakiet Otwarty</b> - dowolnie wybrane i
                                udostępniane przez Operatora funkcjonalności i
                                Treści multimedialne dostępne dla Użytkownika
                                bez konieczności logowania się do Aplikacji. W
                                skład Pakietu Otwartego wchodzi dostęp do:
                                <ol>
                                    <li>
                                        elektronicznego przewodnika po
                                        programach TV,
                                    </li>
                                    <li>
                                        programu telewizyjnego TOYA TV HD w
                                        czasie rzeczywistym (online),
                                    </li>
                                    <li>obrazu z kamer internetowych.</li>
                                </ol>
                            </li>
                            <li>
                                <b>Dostęp do Usługi TOYA GO</b> – sposób
                                komunikacji Terminala abonenckiego, na którym
                                będzie użytkowana Aplikacja z siecią TOYA.
                                Dostęp ten może mieć dwa typy:
                                <ol>
                                    <li>
                                        Dostęp w domu – w którym Terminal
                                        abonencki, na którym będzie użytkowana
                                        Aplikacja komunikuje się poprzez
                                        Urządzenie dostępowe TOYA,
                                    </li>
                                    <li>
                                        Dostęp poza domem – w którym Terminal
                                        abonencki, na którym będzie użytkowana
                                        Aplikacja komunikuje się w dowolny
                                        sposób z siecią Internet zapewniając
                                        dostęp do Sieci TOYA.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                    <li>Korzystanie z Usługi TOYA GO wymaga:</li>
                    <ol>
                        <li>W przypadku korzystania jako Użytkownik:</li>
                        <ol>
                            <li>
                                zainstalowania Aplikacji w wersji zgodnej z
                                modelem Terminala abonenckiego na którym będzie
                                użytkowana Aplikacja,
                            </li>
                            <li>zaakceptowania Regulaminu TOYA GO.</li>
                        </ol>
                        <li>W przypadku korzystania jako Abonent:</li>
                        <ol>
                            <li>
                                zainstalowania Aplikacji w wersji zgodnej z
                                modelem Terminala abonenckiego na którym będzie
                                użytkowana Aplikacja,
                            </li>
                            <li>
                                zalogowania się przy użyciu danych logowania do
                                eBOA,
                            </li>
                            <li>zaakceptowania Regulaminu TOYA GO.</li>
                        </ol>
                    </ol>
                </ol>
                <h2>II. FUNKCJONALNOŚCI USŁUGI</h2>
                <ol>
                    <li>
                        Usługa TOYA GO świadczona Abonentowi polega w
                        szczególności na:
                    </li>
                    <ol>
                        <li>
                            udostępnianiu Treści multimedialnych w ilości
                            wynikającej z:
                        </li>
                        <ol>
                            <li>
                                posiadanego przez Abonenta pakietu usługi
                                telewizji TOYA,
                            </li>
                            <li>typu Dostępu do usługi TOYA GO</li>
                        </ol>
                        <li>
                            umożliwieniu korzystania z Funkcjonalności
                            dodatkowych, do których dostęp uzależniony jest od
                            posiadanego typu Terminala abonenckiego, na którym
                            będzie użytkowana Aplikacja.
                        </li>
                        <li>udostępnieniu Pakietu Otwartego.</li>
                    </ol>
                    <li>
                        Wykaz programów telewizyjnych które mogą być
                        udostępnione w Usłudze TOYA GO wraz ze wskazaniem, typu
                        Dostępu do usługi TOYA GO, umieszczany jest na stronach
                        internetowych TOYA www.toya.net.pl.
                    </li>
                    <li>
                        Usługa TOYA GO wykorzystuje pasmo usługi internetowej z
                        jakiego korzysta urządzenie, na którym jest
                        zainstalowana i w maksymalnej jakości wykorzystuje do
                        5Mb/s, przy czym jakość obrazu telewizyjnego dostępnego
                        w Usłudze TOYA GO jest dostosowywana dynamicznie do
                        prędkości dostępu do sieci Internet, z której w danym
                        momencie korzysta Abonent lub Użytkownik. TOYA nie
                        odpowiada za pogorszenia jakości obrazu oraz jego
                        zakłócenia związane z tym faktem.
                    </li>
                </ol>
                <h2>III. ZASADY KORZYSTANIA Z USŁUGI</h2>
                <ol>
                    <li>Korzystanie z Usługi TOYA GO wymaga:</li>
                    <ol>
                        <li>
                            podłączenia Terminala abonenckiego na którym będzie
                            użytkowana Usługa TOYA GO do sieci Internet i
                            zapewnienia dla Usługi TOYA GO szybkości transmisji
                            do Sieci TOYA nie mniejszej niż 512 kb/s,
                        </li>
                        <li>zaakceptowania Regulaminu TOYA GO,</li>
                        <li>
                            zainstalowania Aplikacji na Terminalu abonenckim
                            poprzez:
                        </li>
                        <ol>
                            <li>
                                serwis Google Play dla urządzeń z systemem
                                operacyjnym Android
                            </li>
                            <li>
                                serwis App Store dla urządzeń z systemem
                                operacyjnym iOS
                            </li>
                            <li>
                                stronę TOYA go.toya.net.pl dla pozostałych
                                systemów operacyjnych
                            </li>
                        </ol>
                    </ol>
                    <li>
                        Dostęp do Usługi TOYA GO może nastąpić równolegle z
                        użyciem pięciu różnych rodzajów Terminali abonenckich,
                        przy czym ilość urządzeń wykorzystywanych jednocześnie
                        do korzystania z Treści multimedialnych jest ograniczona
                        do dwóch.
                    </li>
                    <li>
                        Opłata za dostęp do Usługi TOYA GO określony jest w
                        Cenniku Usług TOYA. Opłaty pobierane są również z tytułu
                        korzystania z płatnych materiałów z bazy VOD.
                        Korzystanie z bazy VOD oraz wnoszenie opłat odbywa się
                        według zasad określonych w Rozdziale XI Regulaminu
                        korzystania z usług TOYA, który dostępny jest na stronie
                        www.toya.net.pl oraz w Biurach Obsługi Abonenta
                        Operatora.
                    </li>
                    <li>
                        W przypadku rozwiązania Umowy Abonent traci możliwość
                        korzystania z Treści multimedialnych dostępnych po
                        zalogowaniu.
                    </li>
                    <li>
                        Operatorowi przysługuje prawo do umieszczania reklam
                        przed wszystkimi Treściami multimedialnymi.
                    </li>
                    <li>
                        Operatorowi przysługuje prawo do blokowania dostępu do
                        wybranych audycji programów telewizyjnych dostępnych
                        poprzez Usługę TOYA GO, do których nadawcy nie mają
                        praw.
                    </li>
                </ol>
                <h2>IV. WYMOGI SPRZĘTOWE</h2>
                <ol>
                    <li>
                        Terminal abonencki na którym będzie użytkowana Usługa
                        TOYA GO powinno spełniać następujące wymagania:
                    </li>
                    <ol>
                        <li>
                            dla komputera osobistego PC - procesor o szybkości
                            taktowania min. 1,6 Ghz, pamięć RAM min. 512 MB, z
                            systemem operacyjnym Windows 10 lub wyższym z
                            aktualną przeglądarką internetową Microsoft Edge,
                            Mozilla Firefox lub Chrome, włączoną obsługą Java
                            Script, z włączoną obsługą plików „cookies”, ze
                            wsparciem systemów szyfrowania DRM - Widevine DRM.
                        </li>
                        <li>
                            dla Komputerów Mac - z systemem operacyjnym Mac OS X
                            11 lub wyższy z aktualną przeglądarką Safari,
                            Mozilla Firefox, z włączoną obsługą Java Script, z
                            włączoną obsługą plików „cookies”, ze wsparciem
                            systemów szyfrowania DRM - Apple FairPlay DRM.
                        </li>
                        <li>
                            dla smartfonu lub tabletu z dostępem do sieci
                            Internet - z systemem operacyjnym Android 11 lub
                            nowszym, lub z systemem operacyjnym iOS 12 lub
                            nowszym.
                        </li>
                    </ol>
                </ol>
                <h2>VI. PRAWA AUTORSKIE</h2>
                <ol>
                    <li>
                        Wszelkie prawa autorskie, związane z korzystaniem z
                        Usługi TOYA GO, przysługują odpowiednio Operatorowi lub
                        dostawcom Treści multimedialnych.
                    </li>
                    <li>
                        Prawo do korzystania z Treści multimedialnych udzielane
                        jest na podstawie licencji, a uprawnienia Abonenta i
                        Użytkownika wynikają z postanowień Regulaminu TOYA GO.
                    </li>
                    <li>
                        Użytkownik oraz Abonent Usługi TOYA GO uprawnieni są do
                        korzystania z niej wyłącznie na terytorium
                        Rzeczpospolitej Polskiej oraz w Strefie Euro.
                    </li>
                    <li>
                        W związku z postanowieniami niektórych umów licencyjnych
                        zawartych przez Operatora, dostęp do wybranych Treści
                        multimedialnych możliwy będzie wyłącznie w lokalu
                        Abonenta lub wyłącznie za pośrednictwem sieci TOYA
                        (Dostęp z domu opisany w rozdziale 1 ust. 3j podpunkt
                        a).
                    </li>
                    <li>
                        Zarówno Treści multimedialne, jak i Funkcjonalności
                        dodatkowe mogą być wykorzystywane jedynie do własnego
                        użytku osobistego Użytkownika oraz Abonenta, w
                        rozumieniu ustawy o prawie autorskim i prawach
                        pokrewnych z dnia 4 lutego 1994 r (Dz. U. 2006 poz. 90
                        nr 631). Zabronione jest w szczególności:
                    </li>
                    <ol>
                        <li>
                            kopiowanie, powielanie, transmisja, modyfikacja,
                            zmiana, dekonstruowanie, naśladowanie,
                            dekompilowanie lub rozbieranie treści lub
                            funkcjonalności Usługi TOYA GO oraz Aplikacji w
                            jakikolwiek sposób ani wytwarzanie dzieł podobnych,
                        </li>
                        <li>
                            wykorzystanie Usługi TOYA GO, Aplikacji lub
                            jakichkolwiek ich treści lub funkcjonalności, do
                            tworzenia narzędzia lub oprogramowania, mogących być
                            wykorzystanymi do tworzenia aplikacji programowych o
                            jakimkolwiek charakterze,
                        </li>
                        <li>
                            wypożyczanie, wydzierżawianie, publiczne
                            udostępnianie, sprzedaż lub dystrybucja Usługi TOYA
                            GO lub jakichkolwiek zawartych w niej treści lub
                            funkcjonalności,
                        </li>
                        <li>
                            naruszenie integralności Usługi TOYA GO, omijanie
                            jakichkolwiek zabezpieczeń technicznych
                            zastosowanych w Aplikacji, przez Operatora lub
                            dostawców Treści multimedialnych,
                        </li>
                        <li>
                            naruszenie licencyjnych ograniczeń terytorialnych
                            Usługi TOYA GO,
                        </li>
                        <li>
                            tworzenie fałszywych/nieprawdziwych kont w eBOA.
                        </li>
                    </ol>
                    <li>Operator nie ponosi odpowiedzialności za:</li>
                    <ol>
                        <li>
                            niezgodne z Regulaminem TOYA GO korzystanie z Usługi
                            TOYA GO przez Abonenta lub Użytkownika,
                        </li>
                        <li>
                            przerwy lub zakłócenia w dostępnie do Usługi TOYA GO
                            wynikające z działań albo zaniechań osób trzecich
                            lub użytkowników, w szczególności wynikających z
                            zakłóceń w dostępie do Internetu.
                        </li>
                    </ol>
                    <li>
                        Naruszenie postanowień opisanych w ust. 5 niniejszego
                        Rozdziału stanowi podstawę do zablokowania dostępu do
                        Usługi TOYA GO w trybie natychmiastowym z winy Abonenta
                        lub Użytkownika.
                    </li>
                </ol>
                <h2>VII. DANE OSOBOWE</h2>
                <ol>
                    <li>
                        Administratorem Państwa danych osobowych jest TOYA Sp. z
                        o.o. z siedzibą w Łodzi przy ul. Łąkowej 29, a z
                        inspektorem ochrony danych można skontaktować się
                        wysyłając wiadomość na adres: e-mail odo@toya.com.pl.
                    </li>
                    <li>
                        Dane osobowe Abonentów przetwarzane są w celu wykonania
                        umowy o świadczenie usług, wypełnienia obowiązku
                        prawnego (np. wystawianie faktur) i realizacji prawnie
                        uzasadnionych interesów (np. dochodzenie roszczeń lub
                        marketing bezpośredni). Niektóre operacje przetwarzania
                        realizowane są wyłącznie w oparciu o Państwa zgodę.
                    </li>
                    <li>
                        Dane Abonentów będą przetwarzane w okresie obowiązywania
                        umowy, a po jej zakończeniu w okresie dochodzenia
                        roszczeń. Dane dotyczące wykonanych usług przechowywane
                        będą przez 1 rok od użycia usługi.
                    </li>
                    <li>
                        Państwa dane mogą podlegać profilowaniu w celu doboru
                        prezentowanych reklam. Profilowanie odbywa się wyłącznie
                        za Państwa zgodą, w celach marketingowych poprzez
                        prowadzenie badań, ocenę zainteresowań i preferencji
                        zakupowych w oparciu o spseudonimizowane informacje
                        dotyczące wykorzystanych usług pobrane z Terminala
                        abonenckiego, w celu oferowania usług o wartości
                        dodanej, prezentowania reklam produktów i usług w
                        oparciu o określone preferencje. Oferowanie usług i
                        prezentowanie reklam będzie odbywało się za
                        pośrednictwem Państwa Terminala abonenckiego.
                        Umożliwienie profilowania jest dobrowolne, a
                        konsekwencją niewyrażenia zgody będzie wyświetlanie
                        losowo wybranych reklam.
                    </li>
                    <li>
                        Odbiorcami danych osobowych mogą być jedynie podmioty
                        posiadające do tego podstawę prawną. Profilowanie odbywa
                        się we współpracy z firmą Gemius Polska, Google Ireland
                        i TVN Media Sp. z o.o. Firmy te będą miały dostęp do
                        informacji wyłącznie w formie spseudonimizowanej,
                        uniemożliwiającej im połączenie uzyskanych informacji z
                        konkretną osobą. Ewentualny transfer tych danych poza
                        EOG przez firmę Google będzie się odbywał wyłącznie w
                        ramach programu Data Privacy Framework zapewniającego
                        odpowiedni poziom bezpieczeństwa
                    </li>
                    <li>
                        Abonenci mają prawo do żądania od TOYA Sp. z o.o.
                        dostępu do danych osobowych, sprostowania tych danych i
                        ich przenoszenia, w niektórych przypadkach również do
                        ich usunięcia lub ograniczenia przetwarzania, a także do
                        wniesienia skargi do Prezesa Urzędu Ochrony Danych
                        Osobowych. W związku z prowadzonym profilowaniem mają
                        Państwo również prawo do uzyskania interwencji ludzkiej
                        ze strony TOYA, do wyrażenia własnego stanowiska i do
                        zakwestionowania decyzji podjętej w oparciu o
                        profilowanie.
                    </li>
                    <li>
                        Szczegółowe informacje dotyczące ochrony danych
                        osobowych, zawarte są w polityce prywatności
                        udostępnianej Abonentowi przy zawieraniu umowy i
                        zamieszczonej na stronie internetowej:{' '}
                        <Link href="https://toya.net.pl/strona/polityka-prywatnosci">
                            https://toya.net.pl/strona/polityka-prywatnosci
                        </Link>
                    </li>
                </ol>
                <h2>VIII. POSTĘPOWANIE REKLAMACYJNE</h2>
                <p>
                    W zakresie korzystania z płatnych materiałów z bazy VOD w
                    ramach Usługi TOYA GO Abonentowi lub Użytkownikowi
                    przysługuje prawo do składania reklamacji, do której stosuje
                    się odpowiednio postanowienia Rozdziału VIII Regulaminu
                    korzystania z usług TOYA.
                </p>
                <p>
                    Regulamin przyjęty Uchwałą Zarządu TOYA z dnia 7 listopada
                    2024r., Obowiązuje Abonentów, którzy zawarli Umowę lub
                    zmienili warunki Umowy Aneksem po dniu 9 listopada 2024
                    roku.
                </p>
            </CardContent>
        </Card>
    </Box>
)

export { TermsAndConditionsSection }
